import React, { createRef, Fragment, useRef } from "react";
import Body from "../../components/Body";
import "../../styles/poRequest.scss";
import moment from "moment";
import Table from "../../common/Table";

import { AiFillPrinter } from "react-icons/ai";
import LabelText from "../../common/LabelText";
import numberFormat from "../../common/numberFormat";
import addPrecision from "../../common/addPrecision";
import { Helmet } from "react-helmet-async";
import removeCommas from "../../common/removeCommas";
import LetterHeader from "../../components/LetterHeader";
import LetterFooter from "../../components/LetterFooter";
import AppButton from "../../common/AppButton";
import { IoMdMail } from "react-icons/io";
import OrganizationStore, {
  getOrganizationByid,
} from "../../stores/OrganizationStore";
import { useLocation } from "react-router-dom";
import { usePDF } from "react-to-pdf";
import { useQuery } from "@tanstack/react-query";

const header = [
  { title: "Service Description", name: "serviceDescription" },
  { title: "Hours", name: "hours" },
  { title: "Rate", name: "rate" },
  { title: "Amount", name: "amount" },
];

export default function PoRequest() {
  const location = useLocation();
  const { data } = location.state;

  const { toPDF, targetRef } = usePDF({
    filename: `RPO - ${data.organizationName} - ${data.jobId}.pdf`,
    page: {
      format: "letter",
    },
  });
  const { data: organization } = useQuery({
    queryFn: () => getOrganizationByid(data.organization),
    queryKey: ["organizations", data.organization],
  });
  const handleMail = () => {
    window.open(`mailto:${organization?.email}`);
  };

  return (
    <div>
      <Helmet>
        <title>{`RPO - ${data.organizationName} - ${data.jobId}`}</title>
      </Helmet>
      <Body
        back
        title="PO Request"
        topRight={
          <div className="d-flex" style={{ gap: "0px 20px" }}>
            <AppButton
              onClick={handleMail}
              tooltip="Send Email"
              leftIcon={<IoMdMail size={25} />}
            />
            <AppButton
              tooltip="Print"
              leftIcon={<AiFillPrinter size={25} />}
              onClick={() => toPDF()}
            />
            {/* <ReactToPrint
              trigger={() => {
                // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                // to the root node of the returned component as it will be overwritten.
                return (
                  
                );
              }}
              content={() => printComponent.current}
            /> */}
          </div>
        }
      >
        <br />
        <br />
        <div ref={targetRef} className="po-request">
          <div style={{ padding: "1cm", paddingTop: 0 }}>
            <div>
              <LetterHeader />
            </div>
            <div
              style={{
                height: "3px",
                width: "100%",
                backgroundColor: "black",
                margin: "10px 0px",
              }}
            ></div>
            <div>
              <p>
                Date : {moment(data.jobIssueDate).format("MMMM DD, YYYY")}{" "}
                <br /> Job ID : {data.jobId}
              </p>

              <br />
              <br />
              <div>
                <div className="d-flex">
                  <p>
                    <b>Attention : </b>
                  </p>
                  <p
                    style={{
                      maxWidth: 400,
                      paddingLeft: 5,
                      whiteSpace: "pre-line",
                    }}
                  >
                    {` ${data.attention}`} <br />
                    {data.organizationName}
                    {data.organization.careOf && (
                      <Fragment>
                        <br />
                        {data.organization.careOf}
                      </Fragment>
                    )}
                    <br />
                    {data.poRequestLocation}
                  </p>
                </div>
              </div>
              <div>
                <br />
                <br />
                <b>
                  <u>
                    <p className="text-center" style={{ fontSize: 16 }}>
                      Requesting Purchase Order
                    </p>
                  </u>
                </b>
                <div className="d-flex">
                  <span style={{ paddingRight: 10 }}>Job Location :</span>
                  <p
                    className="text-capitalize"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {!Array.isArray(data?.location) && data.location?.title}
                    {Array.isArray(data?.location) &&
                      data?.location?.map((i) => `${i.title}\n`)}
                  </p>
                </div>

                <div
                  className="d-flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <p>
                    {" "}
                    Starting date:{" "}
                    {moment(data.jobStartDate).format("DD/MM/YYYY")}{" "}
                  </p>
                  <p>
                    {" "}
                    Ending date:{" "}
                    {moment(data.jobEndDate).format("DD/MM/YYYY")}{" "}
                  </p>
                </div>
                <Table
                  normalTable
                  tableClass="table-bordered"
                  header={header}
                  data={data.detailsTable.map((i) => {
                    return {
                      ...i,
                      amount: `$ ${addPrecision(numberFormat(i.amount))}`,
                    };
                  })}
                />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div
                    style={{
                      display: "flex",
                      width: 300,
                      gap: 10,
                      flexDirection: "column",
                    }}
                  >
                    <LabelText
                      label="Subtotal"
                      value={`$ ${addPrecision(numberFormat(data.subtotal))}`}
                    />

                    <LabelText
                      label={`HST  (${data.tax}%)`}
                      value={`$ ${addPrecision(
                        (Number(removeCommas(data.subtotal)) *
                          Number(data.tax)) /
                          100,
                      )}`}
                    />

                    <LabelText
                      label="Total"
                      value={`$ ${addPrecision(numberFormat(data.total))}`}
                    />
                  </div>
                </div>
                <br />
                <br />
                <p style={{ whiteSpace: "pre-line" }}>{data.helpText}</p>
              </div>
            </div>
          </div>
          <LetterFooter />
        </div>
      </Body>
    </div>
  );
}
